import * as React from 'react';

import * as agui from 'arm-gui/dist/controls';
import { Utils, isAuth, NumberFormatter, domain, domainVal, i18n, DateFormatter } from 'arm-common';
import BtnDelete from '../shared/BtnDelete.jsx'

class CategorieProdottoDetails extends React.Component {
    constructor(props) {
        super(props),
            this.componentName = "[CategorieProdottoDetails.jsx]"

    }


    render() {
        return (
            <div>
                <div className="card-body">
                    <div className="row">
                        <dt className="col-sm-4 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.NOME', 'Nome')}</dt>
                        <dd className="col-sm-8 col-6">{this.props.categoriaProdotto ? this.props.categoriaProdotto.nome : "-"}</dd>
                    </div>
                    <div className="row">
                        <dt className="col-sm-4 col-6 ">{i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZINE', 'Descrizione')}</dt>
                        <dd className="col-sm-8 col-6">{this.props.categoriaProdotto ? this.props.categoriaProdotto.descrizione : "-"}</dd>
                    </div>
                    <div className="row">
                        {/* <dt className="col-sm-4 col-6 ">{i18n('ARM_CORE_PRODUCT.SHARED.SINGLA', 'Sigla')}</dt>
                        <dd className="col-sm-8 col-6">{this.props.categoriaProdotto ? this.props.categoriaProdotto.sigla : "-"}</dd> */}
                    </div>
                    <div className="row">
                        <dt className="col-sm-4 col-6 ">{i18n('ARM_CORE_PRODUCT.SHARED.ORDINE', 'Ordine')}</dt>
                        <dd className="col-sm-8 col-6">{this.props.categoriaProdotto ? this.props.categoriaProdotto.ordVis : "-"}</dd>
                    </div>

                </div>
                <div className="p-2 mb-4">
                    {isAuth('V2.ADMIN.PRODUCT.EDIT') &&
                        <div className="float-left">
                            <agui.aButton bs="primary" className="mr-3" icon="fas fa-edit" onClick={this.props.modificaCategoriaProdotto}>{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', 'Modifica')}</agui.aButton>

                        </div>
                    }
                    {isAuth('V2.ADMIN.PRODUCT.DELETE') &&
                        <BtnDelete onClick={this.props.showConfirmPanelDelete} className="float-right mr-2" ></BtnDelete>
                    }
                </div>
            </div>


        )
    }
}



export default (CategorieProdottoDetails)